module.exports = __webpack_public_path__ + "8bc5994dcd812bb8e6c7ead5debae4ac.pdf";